import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/wonderful-life-2021/sponsors/upcoming.jpg',
      link: 'https://www.odysseydance.com',
      alt: 'Odyssey Dance Upcoming performances',
      class: 'webFormat',
    },
    {
      image: '/wonderful-life-2021/sponsors/collard.jpg',
      link: 'http://www.collardchiropractic.com/',
      alt: 'Collard Chiropractic',
      class: 'webFormat',
    },
    {
      image: '/wonderful-life-2021/sponsors/copa.jpg',
      link: 'http://www.utahcopa.com/',
      alt: 'Utah COPA',
      class: 'webFormat',
    },
    {
      image: '/wonderful-life-2021/sponsors/ODT_Sponsor1.jpg',
      link: '#',
      alt: 'ODT Sponsors',
      class: 'webFormat',
    },
    {
      image: '/wonderful-life-2021/sponsors/ODT_Sponsor2.jpg',
      link: '#',
      alt: 'ODT Sponsors 2',
      class: 'webFormat',
    },
    {
      image: '/wonderful-life-2021/sponsors/intermountain-trailer.jpg',
      link: 'https://www.intermountaintrailer.com/',
      alt: 'Intermountain Trailer',
      class: 'webFormat',
    },
    {
      image: '/wonderful-life-2021/sponsors/pbs.png',
      link: 'https://www.pbsutah.org/callofthecanyon',
      alt: 'PBS Utah',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
